import axios from 'axios';

axios.defaults.headers.common['X-CSRF-Token'] = document.querySelectorAll('meta[name="csrf-token"]')[0]['content'];
export const updateCalendarDesignerPath = (calendar, designer) => {
  return `/admin/calendars/${calendar.id}/calendar_designers/${designer.id}`;
};

export const updateBookingPath = (booking, calendar) => {
  return `/design/calendars/${calendar.id}/bookings/${booking.id}`;
};

export const spamBookingPath = (booking, calendar) => {
  return `${updateBookingPath(booking, calendar)}/spam`;
};

export const updateDesignerPriority = (calendar, designer, priority, onSuccess, onError) => {
  const data = {
    calendar_designer: {
      priority,
    },
  };
  axios
    .patch(updateCalendarDesignerPath(calendar, designer), data)
    .then(response => {
      onSuccess(response.data);
    })
    .catch(onError);
};

export const updateBooking = (calendar, booking, designer, onSuccess, onError) => {
  const data = {
    booking: {
      assigned_designer_id: (designer || {}).id || null,
      sales_notes: booking.sales_notes,
    },
  };
  axios
    .patch(updateBookingPath(booking, calendar), data)
    .then(response => {
      onSuccess(response.data);
    })
    .catch(onError);
};


export const spamBooking = (calendar, booking, designer, onSuccess, onError) => {
  axios
    .post(spamBookingPath(booking, calendar), {})
    .then(response => {
      onSuccess(response.data);
    })
    .catch(onError);
};


// WEBPACK FOOTER //
// ./app/javascript/components/designer_calendars/api/AdminDesignersApi.js